<template>
    <div>
        <v-layout justify-center pa-2>
            <span class=" display-1 grey--text pa-2">{{$t('page.not_pound.code')}}</span>
            <span class=" display-1 grey--text left_border pa-2">{{$t('page.not_found')}}</span>
        </v-layout>
    </div>
</template>
<script>
export default {
    name: 'NotFound'
}
</script>
<style lang="stylus" scoped>
.left_border {
  border-left : 2px solid dimgrey
}
</style>
